var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDroneRadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 208,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 208,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 208,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 208,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 208,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 208,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 256,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 32,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 96,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 160,
    width: 16,
    height: 16,
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,144c0-13.232-10.768-24-24-24s-24,10.768-24,24s10.768,24,24,24S120,157.232,120,144z M96,152c-4.416,0-8-3.584-8-8 s3.584-8,8-8s8,3.584,8,8S100.416,152,96,152z",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,336v-16H352v16h64v16h-16v32h-16v-16H208v16h-16v-32h-16v-16h64v-16H96v16h64v16h-16v64h48v-16h16v34.424 l9.688,14.528C207.528,451.744,200,460.968,200,472v24h16v-24c0-4.416,3.584-8,8-8h3.72H232h128h4.28H368c4.416,0,8,3.584,8,8v24 h16v-24c0-11.032-7.528-20.256-17.688-23.048L384,434.424V400h16v16h48v-64h-16v-16H496z M176,400h-16v-32h16V400z M368,400h-16 v16h16v13.576L355.72,448H236.28L224,429.576V416h112v-16H224v-16h144V400z M432,400h-16v-32h16V400z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.784,346.56l4.44,15.376C322.856,343.264,368,283.256,368,216c0-83.816-68.184-152-152-152 c-21.016,0-41.384,4.312-60.672,12.776l-12.176-24.352l-14.312,7.16l69.904,139.808C194.592,203.704,192,209.544,192,216 c0,13.232,10.768,24,24,24s24-10.768,24-24s-10.768-24-24-24c-0.992,0-1.944,0.176-2.904,0.296l-21.904-43.816 c7.96-2.96,16.272-4.48,24.808-4.48c39.704,0,72,32.296,72,72s-32.296,72-72,72c-39.704,0-72-32.296-72-72v-8h-16v8 c0,48.52,39.48,88,88,88s88-39.48,88-88c0-48.52-39.48-88-88-88c-11.04,0-21.736,2.136-31.968,6.176l-21.544-43.088 C179.528,83.728,197.488,80,216,80c74.992,0,136,61.008,136,136C352,276.168,311.608,329.856,253.784,346.56z M216,208 c4.416,0,8,3.584,8,8s-3.584,8-8,8s-8-3.584-8-8S211.584,208,216,208z",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,208v8c0,33.848,11.024,65.976,31.864,92.896l12.656-9.8C89.856,275.008,80,246.272,80,216v-8H64z",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,216c0-110.28,89.72-200,200-200s200,89.72,200,200c0,29.504-6.32,57.976-18.784,84.608l14.504,6.784 C425.168,278.616,432,247.872,432,216C432,96.896,335.104,0,216,0S0,96.896,0,216c0,83.496,48.912,160.312,124.608,195.72 l6.784-14.504C61.288,364.44,16,293.304,16,216z",
    fill: "silver"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneRadar);
export default __webpack_public_path__ + "static/media/droneRadar.02ef49a5f53ed114f8458252b6c1f629.svg";
export { ForwardRef as ReactComponent };